export const CLASSIFIER_FIELD_DETAILS = ['full', 'et_and_category', 'name_only'];
export const CLASSIFIER_FIELD_FORMATS = ['json', 'compact'];

export function buildFieldListForPrompt(fields, detail = 'full') {
  const mode = CLASSIFIER_FIELD_DETAILS.includes(detail) ? detail : 'full';
  return (fields || []).map((f) => {
    if (mode === 'name_only') {
      return {field_id: f.field_id, name_et: f.name_et};
    }
    if (mode === 'et_and_category') {
      return {
        field_id: f.field_id,
        name_et: f.name_et,
        category: f.category || '',
      };
    }
    return {
      field_id: f.field_id,
      name_et: f.name_et,
      category: f.category || '',
      scope_et: f.scope_et || '',
      keywords: f.keywords || [],
    };
  });
}

export function serializeFieldList(fieldList, format = 'json') {
  if (!fieldList || !fieldList.length) {
    return '[]';
  }
  if (format === 'compact') {
    return JSON.stringify(fieldList);
  }
  return JSON.stringify(fieldList, null, 2);
}
